var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cloneDeep from 'lodash/cloneDeep';
import chartUtils from '../utils/chart-utils';
import constants from './constants';

var SOLIDGAUGECHART_TITLE_OPTIONS = {
    text: null
};

var GAUGESERIES_TITLE_OPTIONS = {
    text: null
};

var HEATMAP_TITLE_OPTIONS = {
    text: null
};

var configureTitle = function configureTitle(widgetConfig, customConfigTitle, seriesDataObj, customConfigLegend) {
    var GaugeConfig = widgetConfig.GaugeConfig,
        ChartConfig = widgetConfig.ChartConfig;

    var tooltipContent = void 0;
    var maxTitleLength = 16;

    if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE) return SOLIDGAUGECHART_TITLE_OPTIONS;

    if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.GAUGESERIES) return GAUGESERIES_TITLE_OPTIONS;

    if (widgetConfig.BulletConfig) {
        var _config = {
            text: null
        };
        return _config;
    }

    if (widgetConfig.HeatmapConfig) return HEATMAP_TITLE_OPTIONS;

    var isDonutChart = ChartConfig && ChartConfig.ChartType.toLowerCase() == 'doughnut';

    if (isDonutChart) {
        var legendLocation = ChartConfig && ChartConfig.LegendLocation && ChartConfig.ShowLegend ? ChartConfig.LegendLocation : 'null';
        var titleFontSize = 12;

        // Set legendLocation and font-size for favourite widgets
        if (isDonutChart && customConfigLegend.enabled === false) {
            legendLocation = 'null';
            titleFontSize = 10;
        }

        var total = seriesDataObj.reduce(function (acc, dataPoint) {
            return acc += dataPoint[ChartConfig.ValueField];
        }, 0);

        var text = null;
        var valueName = ChartConfig.ValueName;
        var _widgetConfig$ChartCo = widgetConfig.ChartConfig,
            ValueFormat = _widgetConfig$ChartCo.ValueFormat,
            CurrencySymbol = _widgetConfig$ChartCo.CurrencySymbol,
            BaseFormat = _widgetConfig$ChartCo.BaseFormat;


        switch (ChartConfig.AggregationType) {
            case chartUtils.aggregationTypes.sum:
                text = "Total " + chartUtils.replaceAll(valueName, "+", " ");
                break;
            case chartUtils.aggregationTypes.count:
                text = "# " + chartUtils.replaceAll(valueName, "+", " ");
                break;
            case chartUtils.aggregationTypes.average:
                text = "Average " + chartUtils.replaceAll(valueName, "+", " ");
                break;
            case chartUtils.aggregationTypes.uniqueCount:
                text = "Unique # " + chartUtils.replaceAll(valueName, "+", " ");
                break;
            default:
                text = "Total " + chartUtils.replaceAll(valueName, "+", " ");
        }

        var tooltipText = text;
        var getHorizontalAlign = function getHorizontalAlign(legendLocation) {
            legendLocation = legendLocation.toLowerCase();
            if (legendLocation === 'left' || legendLocation === 'right' || legendLocation === 'null') return 0;

            return legendLocation === 'top' ? 15 : -15;
        };

        var getVerticalAlign = function getVerticalAlign(legendLocation) {
            legendLocation = legendLocation.toLowerCase();
            if (legendLocation === 'top' || legendLocation === 'bottom' || legendLocation === 'null') return 0;

            return 100 / 2 * (legendLocation === 'left' ? 1 : -1); // adjust by legend width / 2
        };

        text = text && text.length > maxTitleLength ? text.substring(0, maxTitleLength) + '...' : text;
        var doughnutTotal = text + '<br>' + chartUtils.format(total, ValueFormat, CurrencySymbol, null, BaseFormat);
        tooltipContent = '<div style=\'position:relative;text-align:center;top:' + getHorizontalAlign(legendLocation) + 'px;left:' + getVerticalAlign(legendLocation) + 'px;font-size:' + titleFontSize + 'px;font-weight:bold\' title=\'' + tooltipText + '\'> ' + doughnutTotal + ' </div>';
    }

    var config = _extends({
        text: isDonutChart ? tooltipContent : null,
        verticalAlign: 'middle',
        floating: 'true',
        align: 'center',
        useHTML: true
    }, cloneDeep(customConfigTitle));
    return config;
};

export default configureTitle;